import React from 'react';

interface ArrowProps {
  size?: string | number;
  color?: string;
  fillOpacity?: number;
  direction: 'top' | 'bottom' | 'left' | 'right';
}

const ArrowNoLine = ({
  size = '24',
  color = '#CE181E',
  fillOpacity = 1,
  direction,
}: ArrowProps) => {
  const getRotation = (direction: string) => {
    switch (direction) {
      case 'top':
        return '-rotate-90';
      case 'bottom':
        return 'rotate-90';
      case 'left':
        return 'rotate-180';
      default:
        return 'rotate-0';
    }
  };

  return (
    <div className="flex justify-start items-start">
      <div className={`${getRotation(direction)}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M8.83984 7.41L13.4198 12L8.83984 16.59L10.2498 18L16.2498 12L10.2498 6L8.83984 7.41Z"
            fill={color}
          />
        </svg>
      </div>
    </div>
  );
};

export default ArrowNoLine;
